export default "precision highp float;\nprecision highp int;\n\nvarying vec2 vUv;\n\nvoid main () {\n\tgl_FragColor = vec4(1.0, 0.0, 0.0, 1.0);\n}";